import "./button-stack-motion.css";

/**
 * Selected-pill badge. The ring, fill, and check draw only when motion is
 * allowed; otherwise the stylesheet leaves the solid check in place. Hidden
 * from assistive tech so the choice control keeps its own selected state.
 */
function ButtonStackCheckBadge() {
  return (
    <span
      aria-hidden="true"
      className="relative flex size-10 shrink-0 items-center justify-center"
      data-testid="button-stack-check-badge"
    >
      <span className="button-stack-check-ring absolute inset-0 rounded-full" />
      <span className="button-stack-check-fill absolute inset-0 rounded-full bg-night-sky-base">
        <svg
          aria-hidden="true"
          className="size-10"
          fill="none"
          viewBox="0 0 40 40"
        >
          <path
            className="button-stack-check-draw fill-none stroke-white"
            d="M14 23.2667L18 27L27 13"
            pathLength={14}
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
          />
        </svg>
      </span>
    </span>
  );
}

export { ButtonStackCheckBadge };
